<template>
	<article class="fortune-telling">
		<section class="fortune-telling__wrapper">
			<h3 class="fortune-telling__title">今日の運勢</h3>
			<!-- エラー表示 -->
			<div v-if="isError" class="fortune-telling__error">
				<common-error-message>データを正常に<br>取得できませんでした</common-error-message>
			</div>
			<!-- /エラー表示 -->
			<!-- 今日の運勢 -->
			<div v-else class="fortune-telling__normally">
				<div class="fortune-telling__top">
					<h4 class="fortune-telling__top--constellration">{{ constellation[index].name }}</h4>
					<p class="fortune-telling__top--birth">{{ constellation[index].duration }}</p>
					<div class="fortune-telling__top--explanation">
						<div class="fortune-telling__top--img"><img :src="`${constellation[index].characterImage}`" alt=""></div>
						<div class="fortune-telling__top--text">{{ constellation[index].text }}</div>
					</div>
				</div>
				<div class="fortune-telling__bottom">
					<div class="fortune-telling__bottom--list">
						<h5 class="fortune-telling__bottom--text">恋愛運</h5>
						<div class="fortune-telling__bottom--img" :class="`is-love-level${constellation[index].love}`"></div>
					</div>
					<div class="fortune-telling__bottom--list">
						<h5 class="fortune-telling__bottom--text">金運</h5>
						<div class="fortune-telling__bottom--img" :class="`is-money-level${constellation[index].money}`"></div>
					</div>
					<div class="fortune-telling__bottom--list">
						<h5 class="fortune-telling__bottom--text">仕事運</h5>
						<div class="fortune-telling__bottom--img" :class="`is-job-level${constellation[index].job}`"></div>
					</div>
				</div>
				<div class="fortune-telling__button">
					<!-- 上段 -->
					<a href="javascript:void(0);" class="fortune-telling__button--img gtm-link_click_count01" data-gtm-event-cat-label="お天気占い_おひつじ座ボタン" data-gtm-event-act-label="trackingFortuneTellingBtn01" @click="index = 0">
						<img :src="index === 0 ? `${constellation[0].clickBtnImage}` : `${constellation[0].btnImage}`" :alt="`${constellation[0].name}`">
					</a>
					<a href="javascript:void(0);" class="fortune-telling__button--img gtm-link_click_count01" data-gtm-event-cat-label="お天気占い_おうし座ボタン" data-gtm-event-act-label="trackingFortuneTellingBtn02" @click="index = 1">
						<img :src="index === 1 ? `${constellation[1].clickBtnImage}` : `${constellation[1].btnImage}`" :alt="`${constellation[1].name}`">
					</a>
					<a href="javascript:void(0);" class="fortune-telling__button--img gtm-link_click_count01" data-gtm-event-cat-label="お天気占い_ふたご座ボタン" data-gtm-event-act-label="trackingFortuneTellingBtn03" @click="index = 2">
						<img :src="index === 2 ? `${constellation[2].clickBtnImage}` : `${constellation[2].btnImage}`" :alt="`${constellation[2].name}`">
					</a>
					<a href="javascript:void(0);" class="fortune-telling__button--img gtm-link_click_count01" data-gtm-event-cat-label="お天気占い_かに座ボタン" data-gtm-event-act-label="trackingFortuneTellingBtn04" @click="index = 3">
						<img :src="index === 3 ? `${constellation[3].clickBtnImage}` : `${constellation[3].btnImage}`" :alt="`${constellation[3].name}`">
					</a>
					<a href="javascript:void(0);" class="fortune-telling__button--img gtm-link_click_count01" data-gtm-event-cat-label="お天気占い_しし座ボタン" data-gtm-event-act-label="trackingFortuneTellingBtn05" @click="index = 4">
						<img :src="index === 4 ? `${constellation[4].clickBtnImage}` : `${constellation[4].btnImage}`" :alt="`${constellation[4].name}`">
					</a>
					<a href="javascript:void(0);" class="fortune-telling__button--img gtm-link_click_count01" data-gtm-event-cat-label="お天気占い_おとめ座ボタン" data-gtm-event-act-label="trackingFortuneTellingBtn06" @click="index = 5">
						<img :src="index === 5 ? `${constellation[5].clickBtnImage}` : `${constellation[5].btnImage}`" :alt="`${constellation[5].name}`">
					</a>
					<!-- 下段 -->
					<a href="javascript:void(0);" class="fortune-telling__button--img gtm-link_click_count01" data-gtm-event-cat-label="お天気占い_てんびん座ボタン" data-gtm-event-act-label="trackingFortuneTellingBtn07" @click="index = 6">
						<img :src="index === 6 ? `${constellation[6].clickBtnImage}` : `${constellation[6].btnImage}`" :alt="`${constellation[6].name}`">
					</a>
					<a href="javascript:void(0);" class="fortune-telling__button--img gtm-link_click_count01" data-gtm-event-cat-label="お天気占い_さそり座ボタン" data-gtm-event-act-label="trackingFortuneTellingBtn08" @click="index = 7">
						<img :src="index === 7 ? `${constellation[7].clickBtnImage}` : `${constellation[7].btnImage}`" :alt="`${constellation[7].name}`">
					</a>
					<a href="javascript:void(0);" class="fortune-telling__button--img gtm-link_click_count01" data-gtm-event-cat-label="お天気占い_いて座ボタン" data-gtm-event-act-label="trackingFortuneTellingBtn09" @click="index = 8">
						<img :src="index === 8 ? `${constellation[8].clickBtnImage}` : `${constellation[8].btnImage}`" :alt="`${constellation[8].name}`">
					</a>
					<a href="javascript:void(0);" class="fortune-telling__button--img gtm-link_click_count01" data-gtm-event-cat-label="お天気占い_やぎ座ボタン" data-gtm-event-act-label="trackingFortuneTellingBtn10" @click="index = 9">
						<img :src="index === 9 ? `${constellation[9].clickBtnImage}` : `${constellation[9].btnImage}`" :alt="`${constellation[9].name}`">
					</a>
					<a href="javascript:void(0);" class="fortune-telling__button--img gtm-link_click_count01" data-gtm-event-cat-label="お天気占い_みずがめ座ボタン" data-gtm-event-act-label="trackingFortuneTellingBtn11" @click="index = 10">
						<img :src="index === 10 ? `${constellation[10].clickBtnImage}` : `${constellation[10].btnImage}`" :alt="`${constellation[10].name}`">
					</a>
					<a href="javascript:void(0);" class="fortune-telling__button--img gtm-link_click_count01" data-gtm-event-cat-label="お天気占い_うお座ボタン" data-gtm-event-act-label="trackingFortuneTellingBtn12" @click="index = 11">
						<img :src="index === 11 ? `${constellation[11].clickBtnImage}` : `${constellation[11].btnImage}`" :alt="`${constellation[11].name}`">
					</a>
				</div>
			</div>
		</section>
		<!-- /今日の運勢 -->
	</article>
</template>

<script>
// Compornents
import CommonErrorMessage from '@/components/Molecules/CommonErrorMessage'

// ライブラリ
import cmnConst from '@/assets/js/constant.js'

export default {
	name: 'FortuneTelling',
	components: {
		CommonErrorMessage
	},
	data () {
		return {
			constellation: [
				{ name: 'おひつじ座', duration: '03/21 ～ 04/19 生まれ', characterImage: require('@/assets/img/fortune-telling/character-aries.png'), btnImage: require('@/assets/img/fortune-telling/btn-aries.png'), clickBtnImage: require('@/assets/img/fortune-telling/btn-click-aries.png'), text: '', love: 0, money: 0, job: 0 },
				{ name: 'おうし座', duration: '04/20 ～ 05/20 生まれ', characterImage: require('@/assets/img/fortune-telling/character-taurus.png'), btnImage: require('@/assets/img/fortune-telling/btn-taurus.png'), clickBtnImage: require('@/assets/img/fortune-telling/btn-click-taurus.png'), text: '', love: 0, money: 0, job: 0 },
				{ name: 'ふたご座', duration: '05/21 ～ 06/21 生まれ', characterImage: require('@/assets/img/fortune-telling/character-gemini.png'), btnImage: require('@/assets/img/fortune-telling/btn-gemini.png'), clickBtnImage: require('@/assets/img/fortune-telling/btn-click-gemini.png'), text: '', love: 0, money: 0, job: 0 },
				{ name: 'かに座', duration: '06/22 ～ 07/22 生まれ', characterImage: require('@/assets/img/fortune-telling/character-cancer.png'), btnImage: require('@/assets/img/fortune-telling/btn-cancer.png'), clickBtnImage: require('@/assets/img/fortune-telling/btn-click-cancer.png'), text: '', love: 0, money: 0, job: 0 },
				{ name: 'しし座', duration: '07/23 ～ 08/22 生まれ', characterImage: require('@/assets/img/fortune-telling/character-leo.png'), btnImage: require('@/assets/img/fortune-telling/btn-leo.png'), clickBtnImage: require('@/assets/img/fortune-telling/btn-click-leo.png'), text: '', love: 0, money: 0, job: 0 },
				{ name: 'おとめ座', duration: '08/23 ～ 09/22 生まれ', characterImage: require('@/assets/img/fortune-telling/character-virgo.png'), btnImage: require('@/assets/img/fortune-telling/btn-virgo.png'), clickBtnImage: require('@/assets/img/fortune-telling/btn-click-virgo.png'), text: '', love: 0, money: 0, job: 0 },
				{ name: 'てんびん座', duration: '09/23 ～ 10/23 生まれ', characterImage: require('@/assets/img/fortune-telling/character-libra.png'), btnImage: require('@/assets/img/fortune-telling/btn-libra.png'), clickBtnImage: require('@/assets/img/fortune-telling/btn-click-libra.png'), text: '', love: 0, money: 0, job: 0 },
				{ name: 'さそり座', duration: '10/24 ～ 11/22 生まれ', characterImage: require('@/assets/img/fortune-telling/character-scorpius.png'), btnImage: require('@/assets/img/fortune-telling/btn-scorpius.png'), clickBtnImage: require('@/assets/img/fortune-telling/btn-click-scorpius.png'), text: '', love: 0, money: 0, job: 0 },
				{ name: 'いて座', duration: '11/23 ～ 12/21 生まれ', characterImage: require('@/assets/img/fortune-telling/character-sagittarius.png'), btnImage: require('@/assets/img/fortune-telling/btn-sagittarius.png'), clickBtnImage: require('@/assets/img/fortune-telling/btn-click-sagittarius.png'), text: '', love: 0, money: 0, job: 0 },
				{ name: 'やぎ座', duration: '12/22 ～ 01/19 生まれ', characterImage: require('@/assets/img/fortune-telling/character-capricornus.png'), btnImage: require('@/assets/img/fortune-telling/btn-capricornus.png'), clickBtnImage: require('@/assets/img/fortune-telling/btn-click-capricornus.png'), text: '', love: 0, money: 0, job: 0 },
				{ name: 'みずがめ座', duration: '01/20 ～ 02/18 生まれ', characterImage: require('@/assets/img/fortune-telling/character-aquarius.png'), btnImage: require('@/assets/img/fortune-telling/btn-aquarius.png'), clickBtnImage: require('@/assets/img/fortune-telling/btn-click-aquarius.png'), text: '', love: 0, money: 0, job: 0 },
				{ name: 'うお座', duration: '02/19 ～ 03/20 生まれ', characterImage: require('@/assets/img/fortune-telling/character-pisces.png'), btnImage: require('@/assets/img/fortune-telling/btn-pisces.png'), clickBtnImage: require('@/assets/img/fortune-telling/btn-click-pisces.png'), text: '', love: 0, money: 0, job: 0 }
			],
			index: 0,
			isError: false
		}
	},
	mounted () {
		this.importJsonFile()
	},
	methods: {
		importJsonFile () {
			// 今日の日付をyymmdd形式で取得
			const today = new Date()
			const year = today.getFullYear()
			const month = String(today.getMonth() + 1).padStart(2, '0')
			const day = String(today.getDate()).padStart(2, '0')
			const formattedDate = `${year}${month}${day}`
			// 今日の日付名のJSONを呼び出し
			fetch(`${cmnConst.FRONT_URL}static/json/${formattedDate}.json`).then(res => res.json()).then(json => {
				// コンポーネントファイル内で定義した各値に、JSONデータを代入
				for (let i = 0, len = Object.keys(json).length; i < len; i++) {
					this.constellation[i].text = json[i + 1].text
					this.constellation[i].love = json[i + 1].love
					this.constellation[i].money = json[i + 1].money
					this.constellation[i].job = json[i + 1].job
				}
				this.isError = false
			}).catch(error => {
				this.isError = true
				console.log(error)
			})
		}
	}
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variable";

$spacing-5: 0.312rem;

$border-color: #ccc;

$icon-no-color: #ccc;
$icon-love-color: #ff006f;
$icon-money-color: #cd941a;
$icon-job-color: #3162fb;

$love-image: '~@/assets/img/fortune-telling/icon-love.png';
$money-image: '~@/assets/img/fortune-telling/icon-money.png';
$job-image: '~@/assets/img/fortune-telling/icon-job.png';

img {
	display: block;
	width: 100%;
}

.fortune-telling {
	&__error {
		margin: 0;
		position: relative;
		padding-top: 40.8451%;
	}

	&__title {
		font-family: $family-primary;
		padding: 0;
		font-size: $font-size-16;
		color: $primary;
		border-bottom: 2px solid $primary;
		margin: 0 0 $spacing-10;
	}

	&__top {
		&--constellration {
			font-family: $family-primary;
			font-size: $font-size-20;
			line-height: 1.05;
			text-align: center;
			margin-bottom: $spacing-5;
		}

		&--birth {
			font-family: $family-primary;
			font-size: $font-size-14;
			line-height: $line-height;
			text-align: center;
			margin: 0 0 $spacing-5;
		}

		&--explanation {
			display: flex;
			justify-content: center;
			align-items: center;
		}

		&--img {
			width: 39.436%;
			margin: 0 $spacing-10 0 0;
		}

		&--text {
			width: 52.112%;
			font-family: $family-primary;
			font-size: $font-size-14;
			line-height: $line-height;
		}
	}

	&__bottom {
		border-top: 1px solid $border-color;
		border-bottom: 1px solid $border-color;
		margin-bottom: $spacing-20;

		&--list {
			display: flex;
			justify-content: center;
			align-items: center;
			border-bottom: 1px solid $border-color;
			&:last-child {
				border-bottom: 0;
			}
		}

		&--text {
			width: 33.523%;
			font-family: $family-primary;
			font-size: $font-size-14;
			line-height: $line-height;
			border-right: 1px solid $border-color;
			text-align: center;
			margin: $spacing-10 0;
			padding: $spacing-5 0;
		}

		&--img {
			width: 66.477%;
			padding: $spacing-14 0;
			background-repeat: no-repeat;
			background-size: 160px 28px;
			background-position: center;
			// 恋愛運
			&.is-love-level0 {
				background-image: url($love-image), linear-gradient(to right, $icon-no-color 0, $icon-no-color 100%);
			}

			&.is-love-level1 {
				background-image: url($love-image), linear-gradient(to right, $icon-love-color 0, $icon-love-color 20%, $icon-no-color 20%);
			}

			&.is-love-level2 {
				background-image: url($love-image), linear-gradient(to right, $icon-love-color 0, $icon-love-color 40%, $icon-no-color 40%);
			}

			&.is-love-level3 {
				background-image: url($love-image), linear-gradient(to right, $icon-love-color 0, $icon-love-color 60%, $icon-no-color 60%);
			}

			&.is-love-level4 {
				background-image: url($love-image), linear-gradient(to right, $icon-love-color 0, $icon-love-color 80%, $icon-no-color 80%);
			}

			&.is-love-level5 {
				background-image: url($love-image), linear-gradient(to right, $icon-love-color 0, $icon-love-color 100%);
			}

			// 金運
			&.is-money-level0 {
				background-image: url($money-image), linear-gradient(to right, $icon-no-color 0, $icon-no-color 100%);
			}

			&.is-money-level1 {
				background-image: url($money-image), linear-gradient(to right, $icon-money-color 0, $icon-money-color 20%, $icon-no-color 20%);
			}

			&.is-money-level2 {
				background-image: url($money-image), linear-gradient(to right, $icon-money-color 0, $icon-money-color 40%, $icon-no-color 40%);
			}

			&.is-money-level3 {
				background-image: url($money-image), linear-gradient(to right, $icon-money-color 0, $icon-money-color 60%, $icon-no-color 60%);
			}

			&.is-money-level4 {
				background-image: url($money-image), linear-gradient(to right, $icon-money-color 0, $icon-money-color 80%, $icon-no-color 80%);
			}

			&.is-money-level5 {
				background-image: url($money-image), linear-gradient(to right, $icon-money-color 0, $icon-money-color 100%);
			}

			// 仕事愛運
			&.is-job-level0 {
				background-image: url($job-image), linear-gradient(to right, $icon-no-color 0, $icon-no-color 100%);
			}

			&.is-job-level1 {
				background-image: url($job-image), linear-gradient(to right, $icon-job-color 0, $icon-job-color 20%, $icon-no-color 20%);
			}

			&.is-job-level2 {
				background-image: url($job-image), linear-gradient(to right, $icon-job-color 0, $icon-job-color 40%, $icon-no-color 40%);
			}

			&.is-job-level3 {
				background-image: url($job-image), linear-gradient(to right, $icon-job-color 0, $icon-job-color 60%, $icon-no-color 60%);
			}

			&.is-job-level4 {
				background-image: url($job-image), linear-gradient(to right, $icon-job-color 0, $icon-job-color 80%, $icon-no-color 80%);
			}

			&.is-job-level5 {
				background-image: url($job-image), linear-gradient(to right, $icon-job-color 0, $icon-job-color 100%);
			}
		}
	}
	&__button {
		display: flex;
		justify-content: center;
		flex-wrap: wrap;

		&--img {
			width: 15.283%;
			margin: 0 $spacing-5 0 0;

			&:nth-of-type(1) {
				margin: 0 $spacing-5 $spacing-10 0;
			}

			&:nth-of-type(6n) {
				margin-right: 0;
			}
		}
	}
}

</style>
